// Admin login, checked by the server (PHP session + password hash in MySQL).
// The browser only keeps a small marker so the admin panel knows whether to
// show the login page; every save is still verified by the server.
import { api, refresh, installIfNeeded } from "./store";

const SESSION_KEY = "mmat_admin_session";
const SESSION_HOURS = 12;

function getMarker() {
    try {
        const s = JSON.parse(window.localStorage.getItem(SESSION_KEY) || "null");
        return s && Date.now() - s.at < SESSION_HOURS * 3600 * 1000 ? s : null;
    } catch {
        return null;
    }
}

function setMarker(username) {
    try {
        if (username) window.localStorage.setItem(SESSION_KEY, JSON.stringify({ username, at: Date.now() }));
        else window.localStorage.removeItem(SESSION_KEY);
    } catch {}
}

if (typeof window !== "undefined") {
    window.addEventListener("mmat:unauthorized", () => setMarker(null));
}

// Returns false for a wrong username/password; throws if the server can't be reached
export async function login(username, password) {
    try {
        const res = await api("login", { method: "POST", body: { username, password } });
        setMarker(res.username);
    } catch (e) {
        if (/incorrect/i.test(e.message)) return false;
        throw e;
    }
    await installIfNeeded();
    await refresh(); // now includes draft posts
    return true;
}

// Asks the server whether the admin session is still valid
export async function checkSession() {
    const res = await api("me");
    setMarker(res.loggedIn ? res.username : null);
    return res.loggedIn;
}

export async function changeCredentials(username, newPassword) {
    const res = await api("change-login", { method: "POST", body: { username, password: newPassword } });
    setMarker(res.username);
}

export function currentUser() {
    const s = getMarker();
    return s ? s.username : "";
}

export function isLoggedIn() {
    return !!getMarker();
}

export async function logout() {
    setMarker(null);
    try {
        await api("logout", { method: "POST", body: {} });
        await refresh(); // drop draft posts from this browser
    } catch {}
}
